var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 3.625V2C22 1.44772 21.5523 1 21 1H19.375M3.625 1H2C1.44772 1 1 1.44772 1 2V3.625M1 19.375V21C1 21.5523 1.44772 22 2 22H3.625M19.375 22H21C21.5523 22 22 21.5523 22 21V19.375",
    stroke: "#71903E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0781 17C11.0781 17.4142 11.4139 17.75 11.8281 17.75C12.2423 17.75 12.5781 17.4142 12.5781 17H11.0781ZM16.8568 9.41208C17.2139 9.20206 17.333 8.74238 17.123 8.38536C16.913 8.02834 16.4533 7.90916 16.0963 8.11917L16.8568 9.41208ZM7.55995 8.11917C7.20293 7.90916 6.74325 8.02834 6.53324 8.38536C6.32322 8.74238 6.4424 9.20206 6.79942 9.41208L7.55995 8.11917ZM7.72911 9.95895L11.4479 12.1465L12.2084 10.8535L8.48964 8.66605L7.72911 9.95895ZM12.2084 12.1465L15.9271 9.95895L15.1666 8.66605L11.4479 10.8535L12.2084 12.1465ZM11.0781 11.5V17H12.5781V11.5H11.0781ZM15.9271 9.95895L16.8568 9.41208L16.0963 8.11917L15.1666 8.66605L15.9271 9.95895ZM6.79942 9.41208L7.72911 9.95895L8.48964 8.66605L7.55995 8.11917L6.79942 9.41208Z",
    fill: "#71903E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.431 3.048L4.99347 6.83477C4.68803 7.01444 4.50049 7.34234 4.50049 7.6967V15.3028C4.50049 15.6572 4.68803 15.9851 4.99347 16.1647L11.431 19.9515C11.7439 20.1356 12.1321 20.1356 12.445 19.9515L18.8825 16.1647C19.1879 15.9851 19.3755 15.6572 19.3755 15.3028V7.6967C19.3755 7.34234 19.1879 7.01444 18.8825 6.83477L12.445 3.048C12.1321 2.86392 11.7439 2.86392 11.431 3.048Z",
    stroke: "#71903E",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.dce97993bd39f26e6703ecdc5a1766c6.svg";
export { ForwardRef as ReactComponent };